import { useState, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Bread from "../../common/Bread";
import Loader from "../../common/Loader";
import { Pagination } from "@mui/material";
import { LangContext } from "../../context/LangContext";

const MonthlyInterestRates = () => {
  const [isPage, setIsPage] = useState(1);
  const lang = useContext(LangContext);
  const nep = lang.state.np; // true if Nepali

  const breadcrumList = {
    image: "",
    title: nep ? "ब्याज दरहरू" : "Interest Rates",
    l1: nep ? "होम" : "Home",
    l2: nep ? "ब्याज दरहरू" : "Interest Rates",
    l3: "",
  };

  const { isLoading, isFetching, error, data } = useQuery({
    queryKey: ["monthInterestData", isPage],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/interest_rates/all/${isPage}`)
        .then((res) => res.data),
    keepPreviousData: true, // keeps previous page data while fetching new
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  const description = nep
    ? data.items[0]?.DescriptionNepali
    : data.items[0]?.Description;

  return (
    <Bread data={breadcrumList}>
      <div
        className="services-ck-content"
        dangerouslySetInnerHTML={{ __html: description }}
      ></div>

      {data.totalPages && data.totalPages > 1 && (
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <Pagination
            count={data.totalPages}
            page={isPage}
            onChange={(event, value) => setIsPage(value)}
            color="primary"
          />
        </div>
      )}
    </Bread>
  );
};

export default MonthlyInterestRates;
